module.exports = __webpack_public_path__ + "6kr65s1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ranks/34.jpg
// module id = 562
// module chunks = 1